
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jeux/mystere/[date]",
      function () {
        return require("private-next-pages/jeux/mystere/[date].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jeux/mystere/[date]"])
      });
    }
  